module.exports = __webpack_public_path__ + "img/manos.e2e48920.jpg";